import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypeCategoriesApi } from "../../../http/costTypeCategories/api";
import ModalDialog from "../../ui/ModalDialog";

interface DeleteCostTypeCategoryDialogProps {
  costTypeCategoryId: string;
  onClose: () => void;
}

const DeleteCostTypeCategoryDialog: FC<DeleteCostTypeCategoryDialogProps> = ({ costTypeCategoryId, onClose }) => {
  const i18n = useI18n();
  const costTypeCategoriesApi = useCostTypeCategoriesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.costTypeCategories.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            costTypeCategoriesApi
              .deleteAdminCostTypeCategory(costTypeCategoryId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.costTypeCategories.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCostTypeCategoryDialog;
